/* One continuous Syne phrase on the near hemisphere; original artwork stays unchanged. */
(() => {
  const initialize = () => document.querySelectorAll('[data-mb-single-planet]').forEach((element) => {
    if (element.dataset.initialized) return;
    element.dataset.initialized = 'true';
    const canvas = element.querySelector('canvas');
    const context = canvas?.getContext('2d');
    if (!context) return;
    const link = element.closest('a');
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    const image = new Image();
    image.src = element.dataset.imageSrc;
    let ready = false, visible = true, phase = 0, previous = 0, frame = 0;
    let glyphs = [];
    const radius = 114, fontSize = 34, period = 18000;
    const paused = () => reduce.matches || !visible || document.hidden || link?.matches(':hover, :focus-within');
    const draw = () => {
      if (!ready) return;
      const scale = canvas.width / 256;
      context.setTransform(scale, 0, 0, scale, 0, 0);
      context.clearRect(0, 0, 256, 256);
      context.save();
      context.beginPath(); context.arc(128, 128, radius, 0, Math.PI * 2); context.clip();
      const artScale = radius / 65;
      context.drawImage(image, 128 - 181 * artScale, 128 - 174 * artScale, 256 * artScale, 256 * artScale);
      for (const glyph of glyphs) {
        const angle = phase + glyph.offset / radius, depth = Math.cos(angle);
        if (depth <= 0 || glyph.letter === ' ') continue;
        const across = Math.sin(angle);
        context.save();
        context.translate(128 + across * radius * 0.96, 128 + across * radius * 0.10);
        context.rotate(across * 0.035); context.scale(Math.max(0.015, depth), 0.92 + depth * 0.08);
        context.font = `800 ${fontSize}px Syne`; context.textAlign = 'center'; context.textBaseline = 'middle';
        context.lineJoin = 'round'; context.strokeStyle = '#10071c'; context.lineWidth = 3; context.fillStyle = '#fff';
        context.strokeText(glyph.letter, 0, 0); context.fillText(glyph.letter, 0, 0); context.restore();
      }
      context.restore();
    };
    const tick = (time) => {
      frame = 0;
      if (paused()) { previous = 0; return; }
      if (previous) phase = (phase + Math.min(time - previous, 100) / period * Math.PI * 2) % (Math.PI * 2);
      previous = time; draw(); frame = requestAnimationFrame(tick);
    };
    const updateMotion = () => {
      if (paused()) { cancelAnimationFrame(frame); frame = 0; previous = 0; }
      else if (ready && !frame) frame = requestAnimationFrame(tick);
    };
    const resize = () => {
      const size = Math.min(512, Math.max(256, Math.round(element.getBoundingClientRect().width * (window.devicePixelRatio || 1))));
      canvas.width = size; canvas.height = size; draw();
    };
    ['pointerenter', 'pointerleave', 'focusin', 'focusout'].forEach((event) => link?.addEventListener(event, () => requestAnimationFrame(updateMotion)));
    document.addEventListener('visibilitychange', updateMotion);
    reduce.addEventListener('change', updateMotion);
    if ('IntersectionObserver' in window) new IntersectionObserver(([entry]) => { visible = entry.isIntersecting; updateMotion(); }).observe(element);
    if ('ResizeObserver' in window) new ResizeObserver(resize).observe(element);
    Promise.all([image.decode(), document.fonts.load('800 34px Syne')]).then(() => {
      context.font = `800 ${fontSize}px Syne`;
      let advance = 0;
      glyphs = [...'SHOP ALL WORLDS'].map((letter) => {
        const width = context.measureText(letter).width;
        const glyph = { letter, offset: advance + width / 2 }; advance += width; return glyph;
      });
      phase = -context.measureText('SHOP ALL').width / (2 * radius);
      ready = true; resize(); element.dataset.ready = 'true'; updateMotion();
    }).catch(() => { /* The static single-planet SVG and accessible link remain usable. */ });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
